export const pushNewsletterSubmitEventToDatalayer = (newsletterName) => {
  if (typeof dataLayer === 'undefined') {
    return;
  }
  dataLayer.push({
    event: 'newsletterSubmitEvent',
    newsletterName,
  });
};
